import { useLocalTranslation } from '@/hooks/useLocalTranslation';
import ExamCard from '@/components/dashboard/examCard'
import GreyWarning from '@/assets/icons/greyWarning.png'
import WhiteWarning from "@/assets/icons/whiteWarning.png";

import { userWebsitePaths } from '@/constants/userWebsitePaths';
import { examType } from '@/pages/dashboard/constants';

import "./style.css"
import { themes } from '@/constants/colors_v2';
import { useSelector } from 'react-redux';
import { RootState } from '@/store';

export default function ExamView(props: any) {

    const { timeline, common } = useLocalTranslation();
    const customerCare = process.env.REACT_APP_USER_PANEL_URL + userWebsitePaths.customerCare
    const currentTheme = useSelector((state: RootState) => state.currentThemeReducer.currentTheme);

    return (

        <div className='mb-[11px] ExamViewMain timelineSectionsCommonPaddingLeft'>
            {!props.timelineDetails.isEligibleForExam ? (
                <div className={`flex items-center justify-center p-[12px] rounded-[5px] examViewContactSupportCon`}>
                    <img className='w-[15px] h-[15px] mr-[8px]' 
                    src={currentTheme === themes.dark ? WhiteWarning : GreyWarning}
                    alt='greyWarning' />                    
                    <p className='font-medium text-[14px]'>
                        {timeline.examSection.ineligibleText}
                        <a
                            className='ml-[5px] text-[#0173e7] underline'
                            href={customerCare}
                            target="_blank"
                            rel="noopener noreferrer">{common.statusText.contactSupport}</a>
                    </p>
                </div>

            ) : (
                <>
                    <ExamCard
                        exam={props.timelineDetails}
                        isSectionLocked={props.isSectionLocked}
                        timelineDetails={props.timelineDetails}
                        source={"timeline"}
                        examType={examType.exam}
                        // hideThumbnail={true}
                    />
                </>
            )
            }
        </div>
    );
};

